<section
  class="dashboard-page"
  [class.wa-sidebar-expanded]="waUi.sidebarExpanded()"
>
  <header class="page-header">
    <nav class="wa-breadcrumb">
      <a routerLink="/" queryParamsHandling="preserve">Web Analytics</a>
      <span class="sep">/</span>
      <span class="here">Users</span>
    </nav>
    <h1>Users</h1>
  </header>

  @if (loading() && !rows().length) {
    <div class="skeleton-block">
      <p-skeleton height="4rem" styleClass="wa-sk mb-3" />
      <p-skeleton height="20rem" styleClass="wa-sk" />
    </div>
  } @else if (error(); as err) {
    <p-message severity="error" [text]="err" />
  } @else {
    <div class="users-toolbar">
      <div class="wa-search">
        <i class="pi pi-search wa-search-icon"></i>
        <input
          pInputText
          type="search"
          [(ngModel)]="searchInput"
          (keyup.enter)="applySearch()"
          placeholder="Search username"
          class="w-full"
        />
      </div>
      <p-button label="Search" size="small" (onClick)="applySearch()" />
    </div>

    <div class="stat-row stat-row--4 wa-user-summary">
      <p-card styleClass="wa-stat-card">
        <div class="stat-inner">
          <span class="stat-label">Total users</span>
          <span class="stat-value">{{ totalCount() | number }}</span>
        </div>
      </p-card>
    </div>

    <p-card styleClass="wa-table-card">
      <p-table
        [value]="rows()"
        [lazy]="true"
        [paginator]="true"
        [rows]="pageSize"
        [totalRecords]="totalCount()"
        [first]="first"
        [loading]="loading()"
        [sortField]="sortField"
        [sortOrder]="sortOrder"
        (onLazyLoad)="onLazyLoad($event)"
        dataKey="username"
        styleClass="wa-users-table"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="username">
              Username <p-sortIcon field="username" />
            </th>
            <th pSortableColumn="totalEvents" class="col-count">
              Events <p-sortIcon field="totalEvents" />
            </th>
            <th pSortableColumn="sessions" class="col-count">
              Sessions <p-sortIcon field="sessions" />
            </th>
            <th pSortableColumn="lastActive">Last active</th>
            <th>Top type</th>
            <th>Country</th>
            <th>City</th>
            <th>Device</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr
            class="user-row"
            (click)="goUser(row)"
            (keyup.enter)="goUser(row)"
            tabindex="0"
          >
            <td>
              <a
                class="user-link"
                [routerLink]="userPath(row.username)"
                queryParamsHandling="preserve"
                (click)="$event.stopPropagation()"
                >{{ row.username }}</a
              >
            </td>
            <td class="col-count">{{ row.totalEvents | number }}</td>
            <td class="col-count">{{ row.sessions | number }}</td>
            <td class="mono">{{ row.lastActive | slice: 0:19 }}</td>
            <td>{{ row.topEventType }}</td>
            <td><app-country-label [country]="row.country" /></td>
            <td>{{ row.city }}</td>
            <td>{{ row.device }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8">No named users in this range</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  }
</section>
